export default __webpack_public_path__ + "static/media/Enero-Inter2024-(360x600).8cdde30d.webp";